export default "__VITE_ASSET__Z$rRXdWw__"